module.exports = __webpack_public_path__ + "static/img/banner_text.b0c2a1e8.png";